// extracted by mini-css-extract-plugin
module.exports = {"block":"Media-module__block___2ERT_","aside":"Media-module__aside___2wEVd","body":"Media-module__body___31vby"};